// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"Message_screenReaderText__p3Swt","messageContainer":"Message_messageContainer__1wPKJ","message":"Message_message__ui-u2"};